// A loading "bone" — the web equivalent of the app's Skeleton (app/src/components/
// common/Skeleton.js): a block that pulses between the app's primary(700) and
// primary(900) while the content it stands in for is on its way. Purely visual, so
// it is hidden from assistive tech; the screen that shows bones also renders a
// role="status" message saying what is loading. Size and shape come from the
// caller's class (see .skeleton-* in index.css).
export default function Bone({ className = '' }) {
  return <span className={`skeleton ${className}`.trim()} aria-hidden="true" />;
}
